module.exports = __webpack_public_path__ + "img/CFE-School---NEW-landing-page---BLUE-Scheme.dffed78f.jpg";